import _toConsumableArray from "/Users/gabri/repos/black-tar/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { addEffect, invalidate, applyProps } from 'react-three-fiber';
import { update, Globals, FrameLoop } from '@react-spring/core';
export * from '@react-spring/core';
import { createStringInterpolator } from '@react-spring/shared/stringInterpolation';
import colorNames from '@react-spring/shared/colors';
import { extendAnimated, withAnimated } from '@react-spring/animated';
import * as THREE from 'three';
var elements = Object.keys(THREE).filter(function (key) {
  return /^[A-Z]/.test(key);
}); // Extend animated with all the available THREE elements

var animated = extendAnimated(withAnimated, [].concat(_toConsumableArray(elements), ['primitive']), true);
if (addEffect) addEffect(update);
Globals.assign({
  defaultElement: 'group',
  frameLoop: addEffect && new FrameLoop({
    requestFrame: invalidate
  }),
  applyAnimatedValues: applyProps,
  createStringInterpolator: createStringInterpolator,
  colorNames: colorNames
});
export { animated as a, animated };